import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Img from "react-image";

import { parseHTML, getStoryLink } from "../../utilities";
import { colors, FadeInPage } from "../../theme";
import placeholderImg from "../../assets/placeholder-story-item.png";
import btnReadmore from "../../assets/btn-readmore-red.svg";
import btnPlay from "../../assets/btn-play-red.svg";

const Container = styled(FadeInPage)`
  margin-bottom: 68px;
  width: 552px;

  a {
    align-items: ${(props) => (props.centerTitle ? "center" : "flex-start")};
    display: flex;
    text-decoration: none;

    :hover {
      div:first-of-type {
        :before {
          opacity: 1;
        }

        :after {
          transform: translate(-50%, -50%) scale(1);
        }
      }

      h1,
      em {
        border-color: ${colors.primaryColor};
        color: ${colors.primaryColor};
      }
    }
  }

  div:last-of-type {
    padding: 4px 0 0 15px;
  }

  h1 {
    color: black;
    font-weight: 500;
    font-size: 2rem;
    margin-bottom: 7px;
    transition: 0.3s;

    span {
      line-height: 3.2rem;
    }
  }

  p {
    color: ${colors.textColor};
    line-height: 2.4rem;
  }

  em {
    border: 2px solid ${colors.green};
    color: ${colors.green};
    font-style: normal;
    font-weight: 600;
    margin: 0 2px;
    padding: 0 4px;
    text-transform: uppercase;
    transition: 0.3s;
  }
`;

const Image = styled.div`
  display: block;
  position: relative;

  :before {
    background: rgba(16, 0, 43, 0.45);
    content: "";
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    transition: 0.3s;
    width: 100%;
  }

  :after {
    background: white no-repeat;
    background-image: ${(props) =>
      props.scheme === "STORY" ? `url(${btnReadmore})` : `url(${btnPlay})`};
    background-position: ${(props) =>
      props.scheme === "STORY" ? "center" : "calc(50% + 2px) center"};
    background-size: ${(props) => (props.scheme === "STORY" ? "18px" : "14px")};
    border-radius: 50%;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.2);
    content: "";
    height: 42px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%) scale(0);
    transition: 0.3s;
    width: 42px;
  }

  img {
    display: block;
    width: 148px;
  }
`;

function SearchItem({ item }) {
  return (
    <Container as="article" centerTitle={!item.highlights[0]}>
      <Link to={getStoryLink(item.canonical_url)}>
        <Image scheme={item.scheme}>
          <Img
            src={item.thumbnail_url}
            alt={item.title}
            loader={<img src={placeholderImg} alt={item.title} />}
            unloader={<img src={placeholderImg} alt={item.title} />}
          />
        </Image>
        <div>
          <h1>
            {item.highlights[0] ? (
              item.title
            ) : (
              <span>{parseHTML(item.title_highlighted)}</span>
            )}
          </h1>
          {item.highlights[0] && <p>{parseHTML(item.highlights[0])} ...</p>}
        </div>
      </Link>
    </Container>
  );
}

SearchItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    title_highlighted: PropTypes.string.isRequired,
    highlights: PropTypes.array.isRequired,
    scheme: PropTypes.string.isRequired,
    canonical_url: PropTypes.string.isRequired,
    thumbnail_url: PropTypes.string.isRequired,
  }).isRequired,
};

export default SearchItem;
